const env = {
  test: {
    api_host: '//o-test-sino-trackify-api.meetsocial.cn',
    shopify_host: '//test-shopifyplugin-api.sinoclick.com',
  },
  pre: {
    api_host: '//o-pre-sino-trackify-api.meetsocial.cn',
    shopify_host: '//test-shopifyplugin-api.sinoclick.com',
  },
  prod: {
    api_host: '//trackify-api.sinoclick.com',
    shopify_host: '//shopifyplugin-api.sinoclick.com',
  },
};

export default env;
